import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import type { IRootDispatch } from '../../../../store/models';

import analytics from '../../../../modules/analytics';

import SearchTileGrid from './SearchTileGrid';
import { tiles } from './SearchGridTiles';
import { ISearchTile } from '../SearchTile/SearchTile.types';

import { useMetroArea } from './useMetroArea';

export type SearchTileGridContainerProps = {
  isInIncentives?: boolean;
  waitForReady?: boolean;
};

export default function SearchTileGridContainer({
  params,
}) {
  const dispatch = useDispatch<IRootDispatch>();
  const { metroArea } = useMetroArea();

  useEffect(() => {
    analytics.track('client_hp_searchtiles_viewed', {
      service_page_link: false,
      metro: metroArea?.toLowerCase() || null,
    });
  }, [metroArea]);

  const handleTileSearch = (tile: ISearchTile) => {
    dispatch.route.go({
      route: 'search',
      params: {
        ...tile.searchParams,
        ...params,
        source: 'search_tiles',
      },
      notify: true,
    });
  };

  return (
    <SearchTileGrid
      tiles={tiles}
      onSelectTile={handleTileSearch}
    />
  );
}
